export function Divider() {
  return <div className="divider" />;
}

export function VerticalDivider() {
  return <div className="vdivider" />;
}
